import * as ICONS_FILL_12 from "./assets/fill/12";
import * as ICONS_FILL_18 from "./assets/fill/18";
import * as ICONS_OUTLINE_12 from "./assets/outline/12";
import * as ICONS_OUTLINE_18 from "./assets/outline/18";
import { IconSize, IconType } from "./interfaces";

/**
 * A mapping of icon types and sizes to their respective SVG component modules.
 * Developers can use this map to dynamically select the correct icon component
 * based on the `name` prop.
 *
 * @type {Record<IconType, Record<IconSize, Record<string, React.ComponentType<unknown>>>>}
 */
export const ICON_SETS: Record<
  IconType,
  Record<IconSize, Record<string, React.ComponentType<unknown>>>
> = {
  fill: {
    12: ICONS_FILL_12,
    18: ICONS_FILL_18,
  },
  outline: {
    12: ICONS_OUTLINE_12,
    18: ICONS_OUTLINE_18,
  },
};
